export enum Size {
    small = "small",
    medium = "middle",
    large = "large",
}

export enum MappedSizeDefault {
    small = "small",
    medium = "default",
    large = "large",
}

export type SizeKeys = keyof typeof Size;

export const SizeHeightMappings: { [key in Size]: string } = {
    [Size.small]: "24px",
    [Size.medium]: "32px",
    [Size.large]: "40px",
};
